/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
export const emitPixel = (event, data = null) => {
  data ? fbq("track", event, data) : fbq("track", event);
};

export const initPixels = (pixelIdArr) => {
  if (pixelIdArr.length === 0) return;
  pixelIdArr.forEach((pixelId) => {
    fbq("init", pixelId);
  });
  emitPixel("PageView");
};

export const allMainPixelIds = (allFbPixelSets) => {
  const pixelIdArr = [];
  Object.values(allFbPixelSets.pixelSets).forEach((pixelSet) => {
    if (pixelSet.collectionId === "gid://shopify/Collection/0") {
      pixelIdArr.push(pixelSet.pixelId);
    }
  });
  console.log("pixelIdArr(all)", pixelIdArr);
  return pixelIdArr;
};

export const getPixelIds = (collections, allFbPixelSets) => {
  if (!collections) {
    return false;
  }
  let pixelIdArr = [];

  collections.forEach((v) => {
    allFbPixelSets.pixelSets.forEach((p) => {
      const colId = p.collectionId.substring(
        p.collectionId.lastIndexOf("/") + 1
      );
      if (v.id == colId) {
        pixelIdArr.push(p.pixelId);
      }
    });
  });

  pixelIdArr = Array.from(new Set(pixelIdArr));
  console.log("PixelId", pixelIdArr);
  return pixelIdArr;
};

export const getTitlePrice = (getProductsData) => {
  let data = null;
  if (window.location.href.indexOf("?variant=") > -1) {
    const variantId = window.location.href.match(/variant=(\S*)/)[1];

    getProductsData.product.variants.forEach((v) => {
      if (v.id == variantId) {
        data = {
          price: v.price,
          title: `${getProductsData.product.title} - ${v.title}`,
        };
      }
    });

    if (data) {
      return data;
    }
    return null;
  }
};
